<template>
  <TableContext v-bind="$attrs">
    <span class="capacity-icon" @click="onCapacityClicked">C</span>
  </TableContext>
</template>

<script>
import TableContext from './TableContext';

export default {
  name: 'EmployeeContext',
  components: {
    TableContext,
  },
  props: {
    onCapacityClicked: Function,
  },
};
</script>

<style scoped>
.capacity-icon {
  color: #12539e;
  cursor: pointer;
  font-weight: medium;
  font-size: 19px;

}
</style>
